<template>
  <header :class="{ navShown: navShown }">
    <div class="brand">
      <div><router-link :to="{ name: 'timeline' }"><img src="/static/images/pft_logo_sml.png" height="38" /></router-link></div>
      <h3>Healthy Schools Tracker</h3>
    </div>
    <button v-if="user" :class="{hamburger: true, 'is-active': navShown }" type="button" @click="navShown = !navShown">
      <span class="hamburger-box">
        <span class="hamburger-inner"></span>
      </span>
    </button>
    <div v-if="user" class="navigation">
      <navigation />
      <div class="logOut">
        <button class="btn" @click="signOut">Log Out</button>
      </div>
      <div class="userprofile">
        <router-link :class="['nav-link']" :to="{ name: 'user' }">
          <img v-if="photoURL" :src="photoURL" class="userprofile"/>
          <img v-else src="/static/images/placeholder-profile.png" class="userprofile"/>
        </router-link>
      </div>
    </div>
  </header>
</template>

<script>
  import Navigation from '@/components/Navigation.vue'
  import firebase from '@firebase/app'
  import '@firebase/auth'
  import database from '@/api/database.js'
  export default {
    name: 'HeaderView',
    components: {
      Navigation
    },
    data () {
      return {
        navShown: false,
        user: undefined,
        photoURL: undefined
      }
    },
    mounted () {
      database.EventBus.$on('user-profile-modified-remotely', this.profileModifiedRemotely)
      database.getCurrentUserAndProfile().then(userAndProfile => {
        if (userAndProfile.user) {
          this.user = userAndProfile.user
          this.photoURL = this.user.photoURL
        }
      })
    },
    methods: {
      signOut() {
        firebase.auth().signOut().then(() => {
          this.$router.replace('/')
        })
      },
      profileModifiedRemotely (profile, profileId) {
        // console.log('updating photo url %s', profile.photoURL)
        this.photoURL = profile.photoURL
      },
    },
  }
</script>

<style scoped>
  header {
    position: fixed;
    display: flex;
    border-bottom: 1px solid rgb(189, 182, 183);
    /* border-bottom: 1px solid white; */
    top: 0;
    left: 0;
    right: 0;
    padding: 5px 25px 0;
    z-index: 20;
    background: white;
    box-shadow: 0 5px 10px rgba(189, 182, 183, 0.1);
  }
  header .brand {
    display: flex;
    padding: 3px 0;
    width: 100%;
  }
  header .brand h3 {
    margin: 6px 13px 0;
    font-size: 1rem;
    font-weight: 425;
    color: #6e5f60;
  }
  header .navigation {
    display: none;
    position: absolute;
    top: 100%;
    margin-top: 1px;
    right: 0;
    left: 0;
    background: white;
    box-shadow: 0 5px 10px rgba(189, 182, 183, 0.4);
  }
  header.navShown .navigation {
    display: block;
  }
  header .hamburger {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 10;
  }
  .login {
    position: absolute;
    top: 10px; 
    right: 10px;
  }
  .logOut {
    float: right;
    margin: 15px 30px;
  } 
  header .logOut .btn {
    background: #f9da9f;
  }
  header .logOut .btn:hover {
    background: #dda229;
  }
  img.userprofile {
    height: 36px;
    width: 36px;
    margin: 15px 30px; 
    clip-path: circle(18px at center);
  }
  @media only screen and (min-width: 1024px) {    
    header .brand {
      display: flex;
      padding-bottom: 0px;
      width: 30%;
    }
    header .hamburger {
      display: none;
    }
    header .brand h3 {
      font-size: 1.4rem;
    }
    header .navigation {
      display: flex;
      width: 70%;
      position: static;
      box-shadow: none;
    }
    header .navigation ul {
      display: flex;
      width: 80%;
    }
    header .logOut {
      white-space: nowrap;
      padding: 7px 0 0;
      margin: 0;
    }
    header .logOut .btn {
      font-size: 0.70rem;
      padding: 5px 7px 5px;
      text-transform: uppercase;
    }
    img.userprofile {
      margin: 0 0 0 8px;
      height: 36px;
      width: 36px;
      clip-path: circle(18px at center);
    }
  }
.hamburger {
  padding: 15px 15px;
  display: inline-block;
  cursor: pointer;
  transition-property: opacity, filter;
  transition-duration: 0.15s;
  transition-timing-function: linear;
  font: inherit;
  color: inherit;
  text-transform: none;
  background-color: transparent;
  border: 0;
  margin: 0;
  overflow: visible; }
  .hamburger:hover {
    opacity: 0.7; }
  .hamburger.is-active:hover {
    opacity: 0.7; }
  .hamburger.is-active .hamburger-inner,
  .hamburger.is-active .hamburger-inner::before,
  .hamburger.is-active .hamburger-inner::after {
    background-color: hsla(0, 5%, 20%, 1); }

.hamburger-box {
  width: 40px;
  height: 24px;
  display: inline-block;
  position: relative; }

.hamburger-inner {
  display: block;
  top: 50%;
  margin-top: -2px; }
  .hamburger-inner, .hamburger-inner::before, .hamburger-inner::after {
    width: 40px;
    height: 3px;
    background-color: hsla(0, 5%, 40%, 1);
    border-radius: 3px;
    position: absolute;
    transition-property: transform;
    transition-duration: 0.15s;
    transition-timing-function: ease; }
  .hamburger-inner::before, .hamburger-inner::after {
    content: "";
    display: block; }
  .hamburger-inner::before {
    top: -10px; }
  .hamburger-inner::after {
    bottom: -10px; }
 .hamburger-inner {
  transition-duration: 0.075s;
  transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19); }
   .hamburger-inner::before {
    transition: top 0.075s 0.12s ease, opacity 0.075s ease; }
   .hamburger-inner::after {
    transition: bottom 0.075s 0.12s ease, transform 0.075s cubic-bezier(0.55, 0.055, 0.675, 0.19); }

.is-active .hamburger-inner {
  transform: rotate(45deg);
  transition-delay: 0.12s;
  transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); }
  .is-active .hamburger-inner::before {
    top: 0;
    opacity: 0;
    transition: top 0.075s ease, opacity 0.075s 0.12s ease; }
  .is-active .hamburger-inner::after {
    bottom: 0;
    transform: rotate(-90deg);
    transition: bottom 0.075s ease, transform 0.075s 0.12s cubic-bezier(0.215, 0.61, 0.355, 1); }
</style>